import api from "../services/api";

interface Alternatives {
    correct: boolean;
    alternative: string;
}

export interface iQuiz {
    id_quiz: string;
    id_jogo: string;
    ordem: number;
    image: string;
    question: string;
    alternatives: Alternatives[];
}


export const getQuizzes = async (id: number): Promise<iQuiz[]> => {
    const response = await api.get(`/list_questions/${id}`).catch((err) => {
        throw err;
    });
    return response.data;
};

